let state = {
  channel:null,
  isPlaying:false
}

const video =  (state = {channel:null, isPlaying:false}, action) =>{
  switch (action.type) {
    case 'CHANNELS_LOADED':
      let property = Object.keys(action.payload)[0]
      return Object.assign({},state,{channel: action.payload[property][Object.keys(action.payload[property])[0]]})
    case 'SET_CHANNEL':
      return Object.assign({},state,{channel:action.payload});
    case 'PLAY':
      return Object.assign({},state, {isPlaying:true})
    case 'STOP':
        return Object.assign({},state, {isPlaying:false})
    default:
      return state;
  }
}


export default video;



// WEBPACK FOOTER //
// ./src/reducers/video.js